import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Group, Text } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";
import { IconCloudCheck, IconCloudOff } from "@tabler/icons-react";
import { useShallow } from "zustand/react/shallow";

import { useAppStore } from "@hooks/store/useAppStore";

import { StyledNetworkNotification } from "./NetworkNotification.styled";


export const NetworkNotification = () => {
  const { t } = useTranslation();
  const { online } = useNetwork();
  const [setIsNetworkDisconnected] = useAppStore(
    useShallow(state => [state.setIsNetworkDisconnected])
  );

  useEffect(() => {
    if (online) setIsNetworkDisconnected(false);
    else setIsNetworkDisconnected(true);
  }, [online]);

  return (
    <StyledNetworkNotification
      className={`${!online ? "show-notification" : "hide-notification"}`}>
      {online ? (
        <Group gap={"xs"} justify="center">
          <IconCloudCheck size={16} />{" "}
          <Text fz={14}>{t("network-connected")}</Text>
        </Group>
      ) : (
        <Group gap={"xs"} justify="center">
          <IconCloudOff color="var(--mantine-color-gray-6)" size={16} />
          <Text fz={14} c="dimmed">
            {t("network-disconnected")}
          </Text>
        </Group>
      )}
    </StyledNetworkNotification>
  );
};
